import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Produktbeispiele from "./pages/Produktbeispiele";
import ImpressumDatenschutz from "./pages/ImpressumDatenschutz";
import CookieBanner from "./CookieBanner";

export default function App() {
  return (
    <Router>
      <CookieBanner />
      <a className="skiplink" href="#main">Zum Inhalt springen</a>
      <Navbar />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produktbeispiele" element={<Produktbeispiele />} />
          <Route path="/impressum-datenschutz" element={<ImpressumDatenschutz />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

